import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

import EmptyState from '../../DesignSystem/EmptyState';
import CustomIcon from '../../DesignSystem/CustomIcon';
import { Icons } from '../../../Themes';

function EmptySearch({ search, postsCount, children }: any) {
  const hasResults = postsCount !== 0;
  const hasSearch = !!search;

  if (!hasSearch) {
    return (
      <EmptyState
        icon={<SearchIcon color="primary" style={{ fontSize: 30 }} />}
        content={
          <Typography variant="body1">
            <FormattedMessage id="SEARCH.EMPTY_SEARCH.NEW_SEARCH" />
          </Typography>
        }
      />
    );
  }

  if (hasSearch && !hasResults) {
    return (
      <EmptyState
        icon={<CustomIcon src={Icons.misc.searchOff} color="primary" size={30} />}
        content={
          <Typography variant="body1">
            <FormattedMessage id="SEARCH.EMPTY_SEARCH.NO_RESULTS" />
          </Typography>
        }
      />
    );
  }

  return <div role="list">{children}</div>;
}

export default EmptySearch;
